// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  customer: __t.identity(),
  phase: __t.string(),
  revision: __t.u64(),
  sinceTick: __t.u64().name("since_tick"),
  expiresTick: __t.u64().name("expires_tick"),
  handoverListingId: __t.u64().name("handover_listing_id"),
  updatedAt: __t.timestamp().name("updated_at"),
});
